import { IconButton, Image } from "@chakra-ui/react";
import { stringShowDeleted } from "../strings";
import IconEye from "../assets/icons/eye.svg";
import IconEyeOff from "../assets/icons/eye-off.svg";
import Tooltip from "./tooltip";

type ShowDeletedToggleProps = {
  showDeleted: boolean;
  setShowDeleted: (value: boolean) => void;
  hasDeletedItems: boolean;
};

const ShowDeletedToggle = ({
  showDeleted,
  setShowDeleted,
  hasDeletedItems,
}: ShowDeletedToggleProps) => {
  if (!hasDeletedItems) return null;

  return (
    <Tooltip label={stringShowDeleted}>
      <IconButton
        variant="outline"
        backgroundColor={showDeleted ? "gray.100" : undefined}
        aria-label={stringShowDeleted}
        icon={<Image boxSize="20px" src={showDeleted ? IconEye : IconEyeOff} />}
        onClick={() => setShowDeleted(!showDeleted)}
      />
    </Tooltip>
  );
};

export default ShowDeletedToggle;
